import React, { Component } from "react";
import sentGAEvent from "@/ga";
import Utils from "@/utils";

import DynamicPhotoWorkEmailRender from "./children/DynamicPhotoWorkEmailRender";
import DynamicPhotoWorkEmailModalRender from "./children/DynamicPhotoWorkEmailModalRender";
import "@/assets/dynamicPhoto.less";

class DynamicPhotoWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitSuccessful: false,
      timeNumber: 0,
      formData: {},
      codeVerifyError: false,
    };
    this.timer = null;
  }

  handleSubmitEmail = e => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    sentGAEvent({
      category: "AnimateOld",
      action: "OldGenerate",
    });
    let flag = Utils.handleVideoEditorTimes('22AO');
    if (flag) {
      return false;
    }
    this.props.handleSubmitEmail(e, () => {
      this.setState({ emailModalVisible: true, formData: e });
    });
    this.setState({ timeNumber: 60 }, () => {
      this.timer = setInterval(() => {
        this.setState({ timeNumber: this.state.timeNumber - 1 }, () => {
          if (this.state.timeNumber <= 0) {
            clearInterval(this.timer);
          }
        });
      }, 1000);
    });
  };

  handleSubmitCode = e => {
    sentGAEvent({
      category: "AnimateOld",
      action: "OldConfirmCode",
    });
    console.log(e);
    this.props.handleSubmitVerifyCode(
      this.state.formData.email,
      e.code,
      () => {
        this.setState({ submitSuccessful: true, emailModalVisible: false });
        if (this.timer) {
          clearInterval(this.timer);
        }
      },
      () => {
        this.setState({ codeVerifyError: true });
      }
    );
  };

  handleResendCodeTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.props.handleSubmitEmail(this.state.formData);
    this.setState({ timeNumber: 60 }, () => {
      this.timer = setInterval(() => {
        this.setState({ timeNumber: this.state.timeNumber - 1 }, () => {
          if (this.state.timeNumber <= 0) {
            clearInterval(this.timer);
          }
        });
      }, 1000);
    });
  };
  componentDidMount() {
    this.setState({ submitSuccessful: this.props.hasEmail });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hasEmail !== this.props.hasEmail) {
      this.setState({ submitSuccessful: this.props.hasEmail });
    }
  }

  render() {
    return (
      <div>
        <DynamicPhotoWorkEmailRender
          isNotVerify={this.props.isNotVerify}
          handleSubmitEmail={this.handleSubmitEmail}
          submitSuccessful={this.state.submitSuccessful}
          email={this.props.email}
          waitingTime={this.props.waitingTime}
          handleSuccessfulBack={() => this.setState({ submitSuccessful: false })}
          handelNextStep={this.props.handelNextStep}
        />
        <DynamicPhotoWorkEmailModalRender
          visible={this.state.emailModalVisible}
          codeVerifyError={this.state.codeVerifyError}
          handleResendCodeTimer={this.handleResendCodeTimer}
          handleSubmit={this.handleSubmitCode}
          onCancel={() => this.setState({ emailModalVisible: false })}
          timeNumber={this.state.timeNumber}
          email={this.state.formData.email}
        />
      </div>
    );
  }
}

export default DynamicPhotoWorkFunction;
